import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog10 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Intro */}
        <p className="paragraph-content">
          Your credit score decides whether banks trust you or not. That small
          three-digit number can unlock a home loan, a new bike, or even your
          first credit card. But most people never learn how to improve it –
          until they get rejected.
        </p>

        <p className="paragraph-content">
          So if you’ve ever thought,{" "}
          <i>“Mujhe loan chahiye par score low hai, ab kya karu?”</i>
          <br />
          This guide is for you.
        </p>

        {/* Why Credit Score Matters */}
        <p className="paragraph-heading">Why Credit Score Matters</p>

        <p className="paragraph-content">
          A good credit score (above 750) tells lenders you handle money
          responsibly. It affects your loan approval speed, interest rate, and
          even credit-card limit. But don’t worry – even if your score is low
          today, you can improve it step by step.
        </p>

        {/* Step 1 */}
        <p className="paragraph-heading">
          Step 1 – Understand Your Credit Report
        </p>

        <p className="paragraph-content">
          Think of your score as a financial report card. It reflects three key
          habits:
        </p>

        <ul>
          <li style={{ marginBottom: 10, color: "black" }}>
            Payment History – Pay on time, always.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            Credit Utilization – Use less than 30% of your card or limit.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            Credit Age – Older accounts help build trust.
          </li>
        </ul>

        <p className="paragraph-content">
          When you understand what affects it, you stop fearing finance and
          start controlling it.
        </p>

        {/* Step 2 */}
        <p className="paragraph-heading">Step 2 – Fix the Basics</p>

        <p className="paragraph-content">
          Here’s your quick action plan for a +100 boost:
        </p>

        <ul>
          <li style={{ marginBottom: 10, color: "black" }}>
            Pay every bill before its due date.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            Avoid taking too many new loans at once.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            Check your credit report and dispute any errors.
          </li>
          <li style={{ marginBottom: 10, color: "black" }}>
            Use auto-pay so you never forget.
          </li>
        </ul>

        <p className="paragraph-content">
          Small steps add up – just like saving ₹50 daily becomes ₹18,000 a
          year.
        </p>

        {/* Step 3 */}
        <p className="paragraph-heading">Step 3 – Track & Grow Smart</p>

        <p className="paragraph-content">
          Complicated bank portals? Skip them. With kPaisa, you can check your
          credit score, get reminders, and learn in simple Hinglish.
        </p>

        <p className="paragraph-content">
          Smart people don’t wait to “earn more.” They start managing better
          with what they already have.
          <br />
          Which one are you?
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">
            Can I improve my score on a low income?
          </h4>
          <p className="faq-answer">
            Yes! Consistency matters more than size. Regular on-time payments
            build trust with lenders, even if the amounts are small.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            How long does it take to see improvement?
          </h4>
          <p className="faq-answer">
            Usually 3–6 months of disciplined payments and controlled credit
            usage.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            What if I’ve never taken a loan before?
          </h4>
          <p className="faq-answer">
            You can start by building a financial footprint using small savings
            or investment products like gold SIPs or micro-investments via
            kPaisa.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog10;
